const timezoneOptions = [
  { value: "America/New_York", label: "Eastern Time (ET)" },
  { value: "America/Chicago", label: "Central Time (CT)" },
  { value: "America/Los_Angeles", label: "Pacific Time (PT)" },
];

const contactTypeOptions = [
  { value: "Lead", label: "Lead" },
  { value: "Customer", label: "Customer" },
];

const dndModeOptions = [
  { value: "read", label: "Read Only" },
  { value: "silent", label: "Silent" },
];

const dndOriginOptions = [
  { value: "api", label: "API" },
  { value: "manual", label: "Manual" },
];

const stateOptions = [
  { value: "NY", label: "New York" },
  { value: "CA", label: "California" },
];

const countryOptions = [
  { value: "USA", label: "United States" },
  { value: "CAN", label: "Canada" },
];


export {
  timezoneOptions,
  contactTypeOptions,
  dndModeOptions,
  dndOriginOptions,
  stateOptions,
  countryOptions,
};
